import type { GlobalState } from 'shared/reducers';
import type { DiffData } from './useDiffData.types';

import * as authSelectors from 'shared/features/auth/auth.selectors';

import { useSelector } from 'react-redux';

export const useDiffData = (): DiffData => {
  const reduxState = useSelector<GlobalState, DiffData['reduxState']>(state => ({
    isAuthenticated: authSelectors.getUserAuthenticatedState(state)
  }));

  const formattedData: DiffData['formattedData'] = {
    isRestricted: !reduxState.isAuthenticated
  };

  return {
    reduxState,
    formattedData
  };
};
